import { render, staticRenderFns } from "./emptyDomains.vue?vue&type=template&id=9044b4ce&scoped=true&"
import script from "./emptyDomains.vue?vue&type=script&lang=js&"
export * from "./emptyDomains.vue?vue&type=script&lang=js&"
import style0 from "./emptyDomains.vue?vue&type=style&index=0&id=9044b4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9044b4ce",
  null
  
)

export default component.exports